// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message .icon-error {
  padding-right: 10px;
}
.message .icon-sucess {
  padding-right: 10px;
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/components/alert/alert.component.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR;AAEI;EACI,mBAAA;AAAR;;AAGA;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;AAAJ","sourcesContent":[".message{\n    .icon-error{\n        padding-right: 10px;\n    }\n    .icon-sucess{\n        padding-right: 10px;\n    }\n}\n.flex{\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
